module.exports = __webpack_public_path__ + "images/cagiva_small3330c880c5c8ccdf058f199377ee3c13.png";